import React from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import PayerSearch from './payer-search'
import DiagnosisSelectWrapper from './diagnosis-select-wrapper'
import InsuranceCoveredLoading from './insurance-covered-loading'
import PrimaryGoalInterstitial from './primary-goal-interstitial'

interface CustomComponentProps {
  question: {
    id: number | string
    text: string
    isRequired?: boolean
    type: string
    component?: string
  }
  // RHF mode
  field?: {
    value: any
    onChange: (value: any) => void
    onBlur: () => void
  }
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: any
  skipValue?: boolean
  error?: string
  onChange?: (value: any) => void
  onSkipChange?: (skipValue: boolean) => void
  // Shared props
  clientId?: number
  responseByQuestionId?: Record<number, any[]>
  allQuestions?: Array<{ id: number | string }>
}

type CustomComponent = React.FC<CustomComponentProps>

const CUSTOM_COMPONENTS: Record<string, CustomComponent> = {
  payerSearch: PayerSearch,
  'payer-search': PayerSearch, // Support kebab-case variant
  payerSarch: PayerSearch, // Support typo variant
  diagnosisSelect: DiagnosisSelectWrapper,
  'diagnosis-select': DiagnosisSelectWrapper, // Support kebab-case variant
  InsuranceCoveredLoading: InsuranceCoveredLoading,
  'insurance-covered-loading': InsuranceCoveredLoading, // Support kebab-case variant
  PrimaryGoalInterstitial: PrimaryGoalInterstitial,
  'primary-goal-interstitial': PrimaryGoalInterstitial, // Support kebab-case variant
}

export const getCustomComponent = (
  componentName?: string
): CustomComponent | null => {
  if (!componentName) return null
  return CUSTOM_COMPONENTS[componentName] || null
}

export const registerCustomComponent = (
  name: string,
  component: CustomComponent
): void => {
  CUSTOM_COMPONENTS[name] = component
}
